import { ILivechatGroup } from "interfaces/entities/livechat";

import {
  IEntityCreateFailure,
  IEntityDeleteSuccess,
  IEntityFetch,
  IEntityFetchFailure,
  IEntityFetchSuccess,
  IEntityUpdate,
  IRequestFailure,
} from "../actions";

interface IIntegrationFlags {
  visitedLiveChatIntegrationTutorial: boolean;
  ticketCreated: boolean;
}

export interface ILiveChatImportDiffItem {
  status: "complete" | "pending" | "readyToImport";
  create: number;
}

export interface ILiveChatImportDiff {
  agents: ILiveChatImportDiffItem;
  groups: ILiveChatImportDiffItem;
  tags: ILiveChatImportDiffItem;
  cannedResponses: ILiveChatImportDiffItem;
}

export interface ILiveChatSelectiveImportStartPayload {
  types: ("agents" | "groups" | "tags" | "cannedResponses")[];
}

export interface ILiveChatSelectiveImportItem {
  status: "complete" | "pending" | "notPerformed";
  date?: string;
  asyncTaskID?: string;
}

export interface ILiveChatSelectiveImport {
  agents: ILiveChatSelectiveImportItem;
  cannedResponses: ILiveChatSelectiveImportItem;
  groups: ILiveChatSelectiveImportItem;
  tags: ILiveChatSelectiveImportItem;
}

export interface ILiveChatImportStatus {
  status: "complete" | "importing" | "failed" | "notPerformed";
  statusChangedAt?: string;
  ticketsImported?: { recent: number; archive: number; spam: number };
}

export enum IntegrationType {
  Shopify = "shopify",
  LiveChat = "livechat",
  OpenWidget = "openwidget",
  Webflow = "webflow",
  ChatBot = "chatbot",
  WordPress = "wordpress",
}

export interface IIntegration {
  id: string;
  type: IntegrationType;
  licenseId: number;
  externalId: string;
  flags?: IIntegrationFlags;
  import?: ILiveChatImportStatus;
  selectiveImport?: ILiveChatSelectiveImport;
  importDiff?: ILiveChatImportDiff;
  groups?: null | { status: "loading" | "success" | "error"; data: null | ILivechatGroup[] };
  createdAt: Date;
  createdBy: string;
  createdByType: "agent";
  updatedAt: Date;
  updatedBy: string;
  active: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  settings?: Record<string, any>;
}

export type IFetchSinglePayload = IEntityFetch;
export type IFetchSingleSuccessPayload = IEntityFetchSuccess<IIntegration>;
export type IFetchSingleFailurePayload = IEntityFetchFailure;

export type IMarkLiveChatIntegrationTutorialAsVisitedSuccessPayload = IEntityUpdate<IIntegration>;
export type IMarkLiveChatIntegrationTutorialAsVisitedFailurePayload = IEntityCreateFailure;

export type ISyncDeleteIntegrationPayload = IEntityDeleteSuccess;

export type ILiveChatSelectiveImportFetchSuccessPayload = IEntityFetchSuccess<ILiveChatSelectiveImport>;
export type ILiveChatSelectiveImportFetchFailurePayload = IRequestFailure;
export type ILiveChatImportDiffSuccessPayload = IEntityFetchSuccess<ILiveChatImportDiff>;
export type ILiveChatImportDiffFailurePayload = IRequestFailure;
export type ILiveChatSelectiveImportStartSuccessPayload = IEntityFetchSuccess<
  { data: ILiveChatSelectiveImport } & ILiveChatSelectiveImportStartPayload
>;
export type ILiveChatSelectiveImportStartFailurePayload = IRequestFailure;

export type LivechatGroup = {
  id: number;
  name: string;
};
